
let language = {
    STANDARD_COMPLETE_PAYMENT_SUCCEED_TITLE: "支付成功",

    STANDARD_COMPLETE_PAYMENT_TIME_TIP1: "该页面会自动跳转到“我的订单”中",
    STANDARD_COMPLETE_PAYMENT_TIME_TIP2: "秒",

    STANDARD_COMPLETE_BACK_ORDER_BTN: "返回我的订单",
    STANDARD_COMPLETE_CONTINUE_SHOPPING_BTN: "继续购物",

    STANDARD_COMPLETE_URL_PARAM_CHECK_ALERT_TITLE: "警告",
    STANDARD_COMPLETE_URL_PARAM_CHECK_ALERT_CONTENT: "缺少订单 ID",
};

export { language }